export class FunctionUtilities {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public static noop() { }

    public static isFunction<T>(value: T | undefined | null): value is T {
        return !!value && typeof (value) === "function";
    }
}
